export const AppStoreUrl = 'https://apps.apple.com/app/id6747647891';
export const GooglePlayUrl = 'https://play.google.com/store/apps/details?id=com.metadevprofile.app';

const getMarketingBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  const parts = hostname.split('.');
  const rootDomain = parts.length > 2 ? parts.slice(1).join('.') : hostname;
  const portSuffix = port ? `:${port}` : '';
  return `${protocol}//${rootDomain}${portSuffix}`;
};

export const marketingPaths = {
  home: '/',
  termsOfUse: '/terms-of-use',
  privacyPolicy: '/privacy-policy',
  contact: '/contact',
} as const;

export const getMarketingUrl = (path: string) => `${getMarketingBaseUrl()}${path}`;
